import React from "react";
import { Handshake, ArrowRight, CheckCircle } from "lucide-react";

const WorkWithUs = () => {
  const benefits = [
    "Opptil 10% provisjon per lokasjon",
    "Ingen salgsarbeid – bare introduser oss",
    "Vi tar hele prosessen derfra",
    "Utbetaling hver måned",
  ];

  return (
    <section
      id="work-with-us"
      className="py-24 md:py-32 bg-[#0A0A0A] relative overflow-hidden"
      data-testid="work-with-us-section"
    >
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FFD84D]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
              Samarbeid
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6 font-['Outfit']">
              Har du gode kontakter?
            </h2>
            <p className="text-xl text-[#A1A1AA] mb-4 leading-relaxed">
              Tjen <span className="text-[#FFD84D] font-semibold">opptil 10% provisjon</span> per lokasjon du bidrar med.
            </p>
            <p className="text-lg text-white font-medium mb-8">
              Du åpner døren – vi tar resten.
            </p>

            {/* Benefits list */}
            <ul className="space-y-3 mb-10">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-[#FFD84D] shrink-0" />
                  <span className="text-[#A1A1AA]">{benefit}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-primary inline-flex items-center gap-2 group"
              data-testid="work-with-us-cta"
            >
              Start samarbeid
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#FFD84D]/20 to-transparent rounded-3xl blur-2xl" />
            <div className="relative bg-[#121212] border border-white/10 rounded-3xl p-8 md:p-12 overflow-hidden">
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-8 bg-[#FFD84D]/10 rounded-2xl flex items-center justify-center">
                <Handshake className="w-10 h-10 text-[#FFD84D]" />
              </div>

              {/* Commission card */}
              <div className="text-center">
                <p className="text-xs text-[#A1A1AA] mb-1">Opptil</p>
                <div className="text-6xl md:text-7xl font-bold text-[#FFD84D] font-['Outfit'] mb-2">
                  10%
                </div>
                <p className="text-xl text-white font-semibold mb-2 font-['Outfit']">
                  Provisjon
                </p>
                <p className="text-[#A1A1AA]">per lokasjon du bidrar med</p>
              </div>

              {/* Divider */}
              <div className="my-8 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

              {/* Quick stats */}
              <div className="grid grid-cols-2 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-white font-['Outfit']">Enkelt</div>
                  <p className="text-sm text-[#A1A1AA]">Ingen salg</p>
                </div>
                <div>
                  <div className="text-2xl font-bold text-white font-['Outfit']">Skalerbart</div>
                  <p className="text-sm text-[#A1A1AA]">Ingen tak</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkWithUs;
